/* @generated */
import * as React from "react";
const polymorphicForwardRef = React.forwardRef;
export {
  polymorphicForwardRef
};
